/**
 * @module actions/UserAccount
 */

import Cookies from 'js-cookie';

import { ApiUpdateAccount } from '../actions/Api';
import { CLEAR_SUCCESS_MESSAGE_DELAY, UserAccountActions } from '../constants/UserAccount';
import { getCookieDomain } from '../lib/ApplicationUtil';
import { getCurrentUsername } from '../lib/ListenerUtils';

const AT_CLASSIC_LOGIN_COOKE_NAME = 'at';

export function clearSuccessMessage() {
  return {
    type: UserAccountActions.USER_ACCOUNT_CLEAR_SUCCESS_MESSAGE,
  };
}

export function setIsEditingAccountInfo(isEditing) {
  return {
    type: UserAccountActions.USER_ACCOUNT_IS_EDITING,
    data: {
      isEditing,
    },
  };
}

export function updateAccountInfo(currentPassword) {
  return {
    type: UserAccountActions.USER_ACCOUNT_UPDATE_ACCOUNT,
    data: {
      currentPassword,
    },
  };
}

export function setGender(gender) {
  event.preventDefault();
  return {
    type: UserAccountActions.SET_GENDER,
    data: {
      gender,
    },
  };
}

export function updateContentSettings(currentPassword, settings = {}) {
  return (dispatch, getState) => {
    const currentUsername = getCurrentUsername(getState());
    const params = Object.assign({ currentUsername, currentPassword }, settings);

    return dispatch(ApiUpdateAccount(params)).then(() => {
      window.setTimeout(() => {
        dispatch(clearSuccessMessage());
      }, CLEAR_SUCCESS_MESSAGE_DELAY);
    });
  };
}

export function clearPasswordForm() {
  return {
    type: UserAccountActions.USER_ACCOUNT_CLEAR_PASSWORD_FORM,
  };
}

export function clearPasswordFormError() {
  return {
    type: UserAccountActions.CLEAR_ERROR_KEY,
  };
}

export function clearDeleteListenerError() {
  return {
    type: UserAccountActions.CLEAR_DELETE_LISTENER_ERROR,
  };
}

export function clearLogOutAllDevicesError() {
  return {
    type: UserAccountActions.CLEAR_LOG_OUT_ALL_DEVICES_ERROR,
  };
}

export function resetLogOutAllDevices() {
  return {
    type: UserAccountActions.RESET_LOG_OUT_ALL_DEVICES,
  };
}

function setCookieWithDateAndValue(state, name, value, date) {
  const domain = getCookieDomain(state);
  Cookies.set(name, value, {
    domain,
    secure: true,
    path: '/',
    expires: date,
  });
}

/*
 * Once a user logs into the classic site, an `at` cookie
 *  with listenerId encoded is set.
 *  This makes it so that a browser will not need to be cookied with pwc (web redesign cookie)
 *    to gain access.
 *  On logout we need to expire this cookie, along with the pwc cookie to prevent non-allowlisted users
 *     from gaining access
 */
export function removeAtCookie(state) {
  const date = new Date();
  date.setTime(0);
  setCookieWithDateAndValue(state, AT_CLASSIC_LOGIN_COOKE_NAME, '', date);
}

export function getAtCookie() {
  return Cookies.get(AT_CLASSIC_LOGIN_COOKE_NAME);
}
